// ═══════════════════════════════════════════════════════════════
// PIXALLOY — Responsive Layout Hook (Phase 2.1)
// ═══════════════════════════════════════════════════════════════
// Detects viewport width and returns layout mode + panel toggles.
// Desktop (>=1024): standard side panels
// Tablet (768-1024): overlay panels, bottom toolbar
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect, useCallback } from "react";

function getMode(w) {
  if (w >= 1024) return "desktop";
  return "tablet";
}

export function useResponsive() {
  const [mode, setMode] = useState(() => getMode(typeof window !== "undefined" ? window.innerWidth : 1200));
  const [leftOpen, setLeftOpen] = useState(false);
  const [rightOpen, setRightOpen] = useState(false);

  useEffect(() => {
    const check = () => {
      const m = getMode(window.innerWidth);
      setMode(m);
      // Auto-close overlays when switching to desktop
      if (m === "desktop") { setLeftOpen(false); setRightOpen(false); }
    };
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const toggleLeft = useCallback(() => {
    setLeftOpen(v => !v);
    setRightOpen(false); // close other panel
  }, []);
  const toggleRight = useCallback(() => {
    setRightOpen(v => !v);
    setLeftOpen(false); // close other panel
  }, []);
  const closeOverlays = useCallback(() => {
    setLeftOpen(false);
    setRightOpen(false);
  }, []);

  const isTablet = mode === "tablet";

  return {
    mode, isTablet,
    leftOpen, rightOpen,
    toggleLeft, toggleRight, closeOverlays,
    setLeftOpen, setRightOpen,
  };
}
